import type {
  AuthenticationToolDef,
  AuthRequiredToolDef,
} from '@form-factory/schema/contracts';

import { MembershipLogin } from './membershipTool/components/MembershipLogin';
import { MembershipRegistration } from './membershipTool/components/MembershipRegistration';
import { createToolComponent } from '../../toolRegistry';
import { Markdown } from '../Markdown';
import { Message } from '../ui';

export const AuthenticationTool = createToolComponent(
  {
    validate: false,
  },
  ({ toolCall, state }) => {
    if (state !== 'result') {
      return null;
    }

    const data = toolCall.content as
      | AuthenticationToolDef
      | AuthRequiredToolDef
      | undefined;

    if (!data) {
      return null;
    }

    const content = data.content;
    const shouldLogin =
      'requiresAuth' in data
        ? data.suggestedAction === 'login'
        : data.shouldLogin;
    const shouldRegister =
      'shouldRegister' in data ? data.shouldRegister : false;

    if (shouldRegister) {
      return (
        <MembershipRegistration registration={{ content, shouldRegister }} />
      );
    }

    if (shouldLogin) {
      return <MembershipLogin login={{ content, shouldLogin }} />;
    }

    return (
      <Message.BubbleGroup>
        <Message.Bubble>
          <Markdown>{content ?? ''}</Markdown>
        </Message.Bubble>
      </Message.BubbleGroup>
    );
  },
);
